import { Popover } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import UserAvatar from 'treeline-react-core-components/UserAvatar';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import WindowSizeThresholdsEnum from '../../enums/WindowSizeThresholdsEnum';
import DrawerAnchor from '../UI/DrawerAnchor';
import IconBadge from '../UI/IconBadge';
import ViewType from '../UI/ViewType';
import { connectToUser } from '../User/containers/UserDataStore';
import { connectToNotices } from '../User/Notices/containers/NoticesDataStore';
import UserOverview from '../User/UserOverview';
import combineConnectors from '../util/combineConnectors';
import YourBooks from '../YourBooks/YourBooks';
import YourBooksDrawerContext from '../YourBooks/YourBooksDrawerContext';
import HeaderTitleSearchAutocomplete from './HeaderTitleSearchAutocomplete';
import TopMenuItems from './TopMenuItems';
import './userAccountAnchor.less';

UserAccountAnchor.propTypes = {
	location: PropTypes.object,
	isMobile: PropTypes.func,
	userDataStore: PropTypes.object,
	noticesDataStore: PropTypes.object,
};

function UserAccountAnchor({
	location,
	isMobile,
	userDataStore,
	noticesDataStore,
}) {
	const [
		isUserOverviewPopoverVisible,
		setIsUserOverviewPopoverVisible,
	] = useState(false);

	const handleUserOverviewPopoverVisiblityChange = isVisible => {
		setIsUserOverviewPopoverVisible(isVisible);
	};

	const closeUserOverviewPopover = () => {
		setIsUserOverviewPopoverVisible(false);
	};

	const renderItem = topMenuItem => {
		return (
			<div className="header-link">
				<div
					className={`header-link-icon icon-${topMenuItem.icon} ${topMenuItem.iconClass}`}
				/>
				<div className="header-text">{topMenuItem.label}</div>
			</div>
		);
	};

	const renderTopMenuItem = (topMenuItem, badge) => {
		return (
			<div
				className={`header-link-frame ${location.pathname ===
					topMenuItem.linkTo && ' header-link-frame-selected'}`}>
				<React.Fragment>
					{topMenuItem === TopMenuItems.YourBooksNav ? (
						renderYourBookDrawerAnchor(topMenuItem)
					) : (
						<Link
							style={{ textDecoration: 'none' }}
							to={topMenuItem.linkTo}>
							{renderItem(topMenuItem)}
							{badge && badge.length > 0 && (
								<IconBadge
									count={badge.length}
									left={topMenuItem.badgeLeft}
								/>
							)}
						</Link>
					)}
				</React.Fragment>
			</div>
		);
	};

	const renderYourBookDrawerAnchor = topMenuItem => {
		return (
			<DrawerAnchor
				closable={true}
				width="60%"
				placement="left"
				renderDrawerContent={drawer => (
					<YourBooksDrawerContext drawer={drawer}>
						<YourBooks viewType={ViewType.Drawer} />;
					</YourBooksDrawerContext>
				)}>
				{renderItem(topMenuItem)}
			</DrawerAnchor>
		);
	};

	const { HomeNav, NotificationsNav, YourBooksNav } = TopMenuItems;
	const isMobileSize = isMobile();
	const { userAvatar } = userDataStore.state;
	var { notices } = noticesDataStore.state;
	notices = notices && notices.filter(nt => !nt.status);

	return (
		<div className="column-spaced-right">
			{!isMobileSize ? (
				<React.Fragment>
					<div
						className="column-spaced"
						style={{
							marginRight: '30px',
							fontWeight: 'normal',
						}}>
						<HeaderTitleSearchAutocomplete />
					</div>
					{renderTopMenuItem(HomeNav)}
					{renderTopMenuItem(NotificationsNav, notices)}
					{renderTopMenuItem(YourBooksNav)}
				</React.Fragment>
			) : (
				<React.Fragment>
					{renderTopMenuItem(NotificationsNav, notices)}
				</React.Fragment>
			)}
			<div className="column-spaced clickable">
				<Popover
					trigger="click"
					placement="bottomRight"
					visible={isUserOverviewPopoverVisible}
					onVisibleChange={handleUserOverviewPopoverVisiblityChange}
					content={
						<UserOverview closePopover={closeUserOverviewPopover} />
					}>
					<div>
						<UserAvatar
							userInitials={userAvatar && userAvatar.initials}
							avatarUri={userAvatar && userAvatar.uri}
							displayName={userAvatar && userAvatar.displayName}
							avatarSizeClass="avatar-small"
						/>
					</div>
				</Popover>
			</div>
			<div className="clear" />
		</div>
	);
}

const connectors = [connectToUser, connectToNotices, withRouter];

export default combineConnectors(connectors)(
	withIsMobile(UserAccountAnchor, WindowSizeThresholdsEnum.Medium),
);
